import { gql, TypedDocumentNode } from '@apollo/client';
import type { OverheadCostLineItem } from '../models/OverheadCostLineItem';

export const GET_OVERHEAD_COST_LINE_ITEMS_QUERY: TypedDocumentNode<{ overheadCostLineItems: OverheadCostLineItem[] }, { filter?: {} }> = gql`
  query GetOverheadCostLineItems($filter: OverheadCostLineItemFilterInput) {
    overheadCostLineItems(where: $filter, order: { description: ASC }) {
      id,
      description,
      totalCost,
      isActive,
      totalAnnualCost,
      annualCostDivisor,
      annualCostMultiplier,
      dateTimePurchased,
      dateTimeDue,
      dateTimePaid,
      recipient,
      notes
    }
  }
`;

export const GET_TOTAL_ACTIVE_ANNUAL_OVERHEAD_COST: TypedDocumentNode<{ totalActiveAnnualOverheadCost: number }> = gql`
  query GetTotalActiveAnnualOverheadCost {
    totalActiveAnnualOverheadCost
  }
`;
